// extracted by mini-css-extract-plugin
export default {"header":"DesignStudioTableHeader_header__mc7dR"};